export const LIST_TABS = {
    staticList: { id: "static-list", title: "si.my-list.tabs.static-list.text" },
    savedSearches: { id: "saved-searches", title: "si.my-list.tabs.saved-searches.text" },
};

export const TABS_LIST = ["static-list", "saved-searches"];
